<template>
  <tr
    class="table-row"
    :class="[
      { 'table-row--alt': alt },
      { 'table-row--clickable': clickable },
      rowClass,
    ]"
    @click="clickable ? $emit('click', $event) : null"
  >
    <slot />
  </tr>
</template>

<script setup>
defineProps({
  /** Zebra striping */
  alt: { type: Boolean, default: false },
  /** Row is clickable (hover + cursor) */
  clickable: { type: Boolean, default: false },
  /** Additional row class */
  rowClass: { type: [String, Object, Array], default: '' },
});

defineEmits(['click']);
</script>

<style scoped>
.table-row {
  @apply border-b border-slate-100 transition-colors duration-200;
  min-height: 52px;
}

.table-row--alt {
  @apply bg-slate-50/40;
}

.table-row--clickable {
  @apply cursor-pointer;
}

@media (hover: hover) {
  .table-row:hover:not(.table-row--empty) {
    background: rgba(212, 160, 23, 0.06);
    box-shadow: inset 0 0 0 1px rgba(212, 160, 23, 0.08);
  }
}

:deep(td) {
  @apply px-6 py-3.5 text-slate-800;
  font-size: 14px;
  vertical-align: middle;
}
:deep(td.table-row__cell--actions) {
  @apply text-right whitespace-nowrap;
}
</style>
